<template>
  <div id="contenedor-main-estadisticas-licitaciones">
    Estadisticas
  </div>
</template>

<script>

export default {
  name: 'MainEstadisticasLicitaciones',
  components: {

  },
  data() {
    return {

    };
  },

};
</script>

<style>

</style>
